import { IPalette, ITheme } from '../shared-models/Colors.types'

//Just use color tokens in lightMode or darkNode

export const palette: IPalette = {
  PRIMARY: {
    2: '#FBFCFE',
    5: '#F5F9FE',
    10: '#EAF2FC',
    20: '#D6E6F9',
    30: '#C1D9F6',
    40: '#ADCDF3',
    50: '#98C0F0',
    60: '#84B3ED',
    70: '#6FA7EA',
    80: '#5B9AE8',
    90: '#468EE5',
    MAIN: '#307FE2',
    110: '#1F73D9',
    120: '#1C66C1',
    130: '#1859A9',
    140: '#154C91',
    150: '#114078',
    160: '#0E3360',
    170: '#0A2648',
    180: '#071930',
    190: '#030D18',
  },

  SECONDARY: {
    10: '#DAE3F7',
    20: '#B5C7F0',
    30: '#91ABE8',
    40: '#6C8FE1',
    50: '#4773D9',
    60: '#295ACA',
    70: '#2249A6',
    80: '#1A3981',
    90: '#13295C',
    MAIN: '#0B1836',
    120: '#09142C',
    140: '#070F21',
  },

  INFO: {
    5: '#F7F8FF',
    10: '#F0F2FE',
    20: '#D2D7FD',
    MAIN: '#6777F8',
    120: '#253DF5',
    140: '#0A20CA',
    160: '#061586',
  },

  NEUTRAL: {
    WHITE: '#FFFFFF',
    2: '#FCFCFC',
    5: '#F7F7F7',
    10: '#EFEFEF',
    20: '#DFDFDF',
    30: '#CFCFCF',
    40: '#ADCDF3',
    50: '#AFAFAF',
    60: '#9F9F9F',
    70: '#8F8F8F',
    80: '#7E7E7E',
    90: '#6E6E6E',
    MAIN: '#5E5E5E',
    110: '#555555',
    120: '#4B4B4B',
    130: '#424242',
    140: '#393939',
    150: '#2F2F2F',
    160: '#262626',
    170: '#1C1C1C',
    180: '#131313',
    190: '#090909',
  },

  GREEN: {
    2: '#FAFDFC',
    5: '#F2FBF6',
    10: '#E5F7EE',
    20: '#CCEFDE',
    30: '#B2E7CD',
    40: '#99DFBD',
    60: '#66CF9C',
    80: '#33BF7B',
    MAIN: '#00AF5A',
    120: '#00934F',
    140: '#007844',
    160: '#005C39',
    180: '#004019',
  },

  YELLOW: {
    10: '#FFF7E5',
    20: '#FFEECC',
    30: '#FFE5B3',
    40: '#FFDD99',
    50: '#FFD480',
    60: '#FFCC66',
    70: '#FFC34D',
    80: '#FFBB33',
    90: '#FFB31A',
    MAIN: '#FFAA00',
    110: '#E69900',
    120: '#CC8800',
    130: '#B37700',
    140: '#996600',
    150: '#805500',
    160: '#664400',
    170: '#4D3300',
    180: '#332200',
    190: '#1A1100',
  },

  RED: {
    1: '#FFFDFD',
    2: '#FEFAFA',
    5: '#FDF3F4',
    10: '#FCE8E9',
    20: '#FACECF',
    40: '#F59DA0',
    60: '#F06B70',
    80: '#EC3A40',
    MAIN: '#D9151C',
    120: '#B91218',
    140: '#980F14',
    160: '#780C0F',
    180: '#57090B',
  },
}

const lightMode: ITheme = {
  PRIMARY: palette.PRIMARY.MAIN,
  SECONDARY: palette.SECONDARY.MAIN,
  INFO: palette.INFO.MAIN,
  NEUTRAL: palette.NEUTRAL.MAIN,
  RED: palette.RED.MAIN,
  YELLOW: palette.YELLOW.MAIN,
  GREEN: palette.GREEN.MAIN,

  /********************* TEXT COLOR ************************/
  text1: palette.NEUTRAL[170],
  text2: palette.NEUTRAL[120],
  text3: palette.NEUTRAL[80],
  text4: palette.NEUTRAL[60],
  disableText: palette.NEUTRAL[30],
  disableTextOnColor: palette.NEUTRAL.WHITE,
  // Accent/Primary Brand
  primaryBrandText: palette.PRIMARY.MAIN,
  primaryBrandTextHover: palette.PRIMARY[120],
  primaryBrandTextPress: palette.PRIMARY[140],
  primaryBrandText2: palette.PRIMARY[40],
  //On Brand
  onBrandText: palette.NEUTRAL.WHITE,
  onBrandText2: palette.PRIMARY[10],
  onBrandText3: palette.PRIMARY[20],
  // System Approve
  approveText: palette.GREEN.MAIN,
  approveTextHover: palette.GREEN[120],
  approveTextPress: palette.GREEN[140],
  // System/Warning
  warningText: palette.YELLOW.MAIN,
  warningText2: palette.YELLOW[140],
  // System/Critical
  criticalText: palette.RED.MAIN,
  criticalTextHover: palette.RED[120],
  criticalTextPress: palette.RED[140],
  criticalText2: palette.RED[60],
  // On Critical
  onCriticalText: palette.NEUTRAL.WHITE,
  /********************* BACKGROUND COLOR ************************/
  //Background
  bg: palette.NEUTRAL.WHITE,
  bgHover: palette.NEUTRAL[2],
  bgPress: palette.NEUTRAL[5],
  bgSelected: palette.PRIMARY[5],
  bg2: palette.NEUTRAL[2],
  bg2Hover: palette.NEUTRAL[5],
  bg2Press: palette.NEUTRAL[10],
  bg3: palette.NEUTRAL[5],
  bg3Hover: palette.NEUTRAL[10],
  bg3Press: palette.NEUTRAL[20],
  bg4: palette.NEUTRAL[10],
  bg4Press: palette.NEUTRAL[20],
  //Disable Background
  disableBg: palette.NEUTRAL[20],
  disableBg2: palette.NEUTRAL[5],
  //Primary Brand
  primaryBrandBg: palette.PRIMARY.MAIN,
  primaryBrandBgHover: palette.PRIMARY[120],
  primaryBrandBgPress: palette.PRIMARY[150],
  primaryBrandBg2: palette.PRIMARY[20],
  primaryBrandBg3: palette.PRIMARY[10],
  primaryBrandBg3hover: palette.PRIMARY[20],
  primaryBrandBg3press: palette.PRIMARY[30],
  primaryBrandBg4: palette.PRIMARY[5],
  primaryBrandBg4Hover: palette.PRIMARY[10],
  primaryBrandBg4Press: palette.PRIMARY[20],
  //System/Approve
  approveBg: palette.GREEN.MAIN,
  approveBgHover: palette.GREEN[120],
  approveBgPress: palette.GREEN[140],
  approveBg2: palette.GREEN[80],
  approveBg3: palette.GREEN[10],
  approveBg3Hover: palette.GREEN[20],
  approveBg3Press: palette.GREEN[30],
  approveBg4: palette.GREEN[5],
  //System/Warning
  warningBg: palette.YELLOW.MAIN,
  warningBg2: palette.YELLOW[20],
  //System/Critical
  criticalBg: palette.RED.MAIN,
  criticalBgHover: palette.RED[120],
  criticalBgPress: palette.RED[140],
  criticalBg2: palette.RED[10],
  criticalBg3: palette.RED[5],
  criticalBg3Hover: palette.RED[10],
  criticalBg3Press: palette.RED[20],
  criticalBg4: palette.RED[2],
  criticalBg4Hover: palette.RED[5],
  criticalBg4Press: palette.RED[10],
  criticalBg5: palette.RED[1],
  /********************* STROKE COLOR ************************/
  //Accent/Primary Brand
  primaryBrandStroke: palette.PRIMARY.MAIN,
  primaryBrandStrokeHover: palette.PRIMARY[120],
  primaryBrandStrokePress: palette.PRIMARY[140],
  primaryBrandStroke2: palette.PRIMARY[20],
  primaryBrandStroke3: palette.PRIMARY[10],
  stroke: palette.NEUTRAL[5],
  stroke2: palette.NEUTRAL[10],
  stroke3: palette.NEUTRAL[20],
  stroke4: palette.NEUTRAL[40],
  stroke5: palette.NEUTRAL[60],
  //System/Approve
  approveStroke: palette.GREEN.MAIN,
  approveStroke2: palette.GREEN[20],
  //System/Critical
  criticalStroke: palette.RED.MAIN,
  criticalStroke2: palette.RED[20],
  criticalStroke3: palette.RED[120],
  criticalStroke4: palette.RED[160],
}

const darkMode: ITheme = {
  // Define your dark mode theme here
}

function getTheme(theme: 'light' | 'dark'): ITheme {
  return theme === 'light' ? lightMode : darkMode
}

export let colors: ITheme = {
  WHITE: 'white',
  BLACK: '#000',
  MODAL_BORDER: '#c6e5da',
  VEHICALE_LICENSE_PLATE: '#f5f7fb',
  PROGRESS: '#c6e5da',
  NOTBOOKABLE: '#b1cfc4',
  ALOWED_TRAFFIC: '#b1cec4',
  LIGHT_WHITE: '#fefeff',
  DARK_GRAY: '#4A4A4A',
  LIGHT_GRAY: '#707070',
  LIGHTER_GRAY: '#989797',
  DARK_PRIMARY: '#30958E',
  ORANGE: '#FF9E0C',
  BLUE: '#0067C5',
  MUTED_TEXT: '#9499a7',
  PAYMENT_BUTTON_BORDER: '#deb9b9',
  PAYMENT_BUTTON_BACKGROUND: '#fce8e8',
  ERROR_CIRCLE: '#ff1e1e',
  PAYMENT_BUTTON_ERROR: '#ff1e1e',
  DEBT_BUTTON: '#f86a6a',
  WARNING_BACKGROUND: '#feebb8',
  WARNING_TEXT: '#ff7700',
  BORDER_BLUE: '#0b183626',
  DISCOUNT_BADGE_ERROR: '#E62044',
  PRIMARY_OPACITY: 'rgba(78, 177, 170, 0.10)',
  ERROR_OPACITY: 'rgba(255, 86, 86, 0.10)',
  SUCCESS_OPACITY: 'rgba(52, 66, 255, 0.10)',
  DARK_GREEN: '#285956',
  WARNING: '#ffbf19',
  WAITING: '#268dea',
  MENU_ITEMS: '#b9ded1',
  BG_ERROR: 'rgba(230, 86, 32, 0.29)',
  PICKUP: '#282c63',
}

colors = { ...colors, ...getTheme('light') }
